<template>
    <div class="confirm-v3-page">
        <div class="order-remark-page" v-if="remarkStatus">
        
            <mt-header fixed title="备注信息" style="background:#3189FF;color:#ffffff;">
                <mt-button icon="back" slot="left" @click="cancelRemark"></mt-button>
                <mt-button slot="right" @click="finishRemark" style="font-size:14px">
                    <span class="sort">
                        完成
                    </span>
                </mt-button>
            </mt-header>

            <div class="remark-content">
                <textarea name="" id="" cols="30" rows="10" placeholder="填写额外的订单备注信息" v-model="remarkContent"></textarea>
            </div>
        </div>

        <div class="ticket-modal" v-if="modalStatus">
            <div class="sheet" :class="{'close':sheetStatus}">
                <div class="title">
                    我的优惠券
                    <img src="../assets/images/popup_close@3x.png" @click="closeSheet">
                </div>
                <div class="content">
                    <img src="../assets/images/popup_coupon_defail@3x.png" alt="">
                    <p>暂时没有优惠券</p>
                </div>
            </div>
        </div>
        
        <mt-header fixed title="订单确认" style="background:#3189FF;color:#ffffff;">
            <mt-button icon="back" slot="left" @click="goBack"></mt-button>
        </mt-header>

        <div class="scroll-wrapper">
            <div class="scroll-content">
                <div class="phone grayBar">
                    <div class="title">
                        <span>填写联系方式</span>
                        <span>(请您认真填写，工程师将通过此号码联系您)</span>
                    </div>
                    <div class="input">
                        <div class="regionNum" @click="showPicker">+&nbsp;{{code}}
                            <img src="../assets/images/global_down_arrow@3x.png" alt="">
                        </div>
                        <input class="phone_num" type="text" v-model="phone" placeholder="请填写手机号">
                    </div>
                    <div class="phone_code" v-if="isShowVerify">
                        <input type="text" placeholder="请填写验证码" v-model="verify_code">
                        <div class="get_code">
                            <span v-if="!sms_show">{{count}}秒后重发</span>
                            <span v-if="sms_show" @click="getSms">获取验证码</span>
                        </div>
                    </div>
                </div>

                <div class="order-info grayBar">
                    <ul class="base-info">
                        <li>
                            <span>商品名称</span>
                            <span>
                                <img :src="goods.thumb">{{goods.title}}
                            </span>
                        </li>
                        <li>
                            <span>基础信息</span>
                            <span>
                                基础检测费{{base_price}}元
                            </span>
                        </li>
                        <li>
                            <span>附加信息</span>
                            <span class="text" :class="{'close':isOpen}">
                                {{tags}}
                            </span>
                            <span v-if="isOpen" @click="changeOpenStatus">展开</span>
                            <span v-if="!isOpen" @click="changeOpenStatus">收起</span>
                        </li>
                    </ul>
                    <div class="time-region">
                        <span>选择时间</span><span>（选择加急服务，下单后可由您指定服务时间）</span>
                    </div>
                    <ul class="time-btns">
                        <li :class="{'active':timeId == item.id}" v-for="item of timeItems" :key="item.id" 
                        @click="selectTime(item)">
                            <span>{{item.name}}</span>
                            <span>
                                ¥{{item.price}}
                                <div class="icon"></div>
                            </span>
                        </li>
                    </ul>
                    <ul class="cost-info">
                        <li>
                            <div>商品金额</div><span>￥{{price}}</span>
                        </li>
                        <li>
                            <div>加急费用</div><span>￥{{urgent}}</span>
                        </li>
                        <li>
                            <div><span style="opacity: 0;">空</span>优惠券</div><span @click="openSheet">无可用券<img src="../assets/images/global_more_arrow@3x.png"></span>
                        </li>
                    </ul>
                </div>
                <div class="attach-info grayBar">
                    <div class="remark" @click="goRemark">
                        <span><span class="title">备注信息</span><span class="content">{{user_demand}}</span></span>
                        <img src="../assets/images/global_more_arrow@3x.png">
                    </div>
                    <div class="huabei" @click="changeHuaBeiList">
                        <span class="text">
                            <img src="../assets/images/buy_antpay@3x.png">
                            <span class="title">花呗分期</span>
                            <span class="value" v-if="huabeiStatus">（分{{hb_times}}期，￥{{per_cost}}/期）</span>
                        </span>
                        <img v-if="huabeiStatus" src="../assets/images/pay_selected.png">
                        <img v-if="!huabeiStatus" src="../assets/images/paytypenor_20x20_@3x.png">
                    </div>
                    <ul class="huabei-list" :class="{'close':!huabeiStatus}" id="huabei" ref="huabei">
                        <li v-for="(item,index) in hb_rates" :key="item.key" :class="{'active':hb_times == item.key}" @click="selectHBItem(index)">
                            <span class="huabei-content">
                                <span>￥{{item.value}} x {{item.key}}期</span><br/>
                                <span>利率：{{item.rate}}%</span>
                            </span>
                        </li>
                    </ul>
                </div>
                <div class="order-tips">
                    <h2>费用及相关服务说明</h2>
                    <p>{{service_description}}</p>
                </div>
            </div>
        </div>
        
        <div class="footer">
            <div class="buy" @click="createOrder">立即下单</div>
            <div class="price"><span>支付金额：</span><span>¥{{total}}</span></div>
        </div>

        <AwesomePicker  ref="pickers" :data="picker.slot" :textConfirm="picker.textConfirm"  :colorConfirm="picker.colorConfirm" :colorCancel="picker.colorCancel" @confirm="handlePickerConfirm"></AwesomePicker >
    </div>
</template>

<script>

import AwesomePicker  from '../assets/lib/awesome-picker'
import _ from 'lodash'
export default {
    metaInfo: {
        title: '果师兄官网_苹果手机数据恢复|微信聊天记录恢复|电脑数据恢复', // set a title
        meta: [{                 // set meta
          name: 'keyWords',
          content: '果师兄恢复大师,苹果数据恢复软件,手机数据恢复软件,电脑数据恢复'
        },{                 // set meta
          name: 'description',
          content: '果师兄恢复大师为用户提供电脑手机数据恢复服务,主要服务包括微信聊 天记录,短信,备忘录,微信好友添加,照片等苹果手机数据恢复,回收站清空文件恢复,U 盘/硬 盘/SD 卡/储存卡等各类存储设备数据恢复,以及相关的数据迁移、数据删除等指导服务'
        }]
    },
    data(){
        return{
            picker:{
                slot:[],
                textConfirm:"完成",
                colorConfirm:"#3189FF",
                colorCancel:"#3189FF"
            },
            huabeiStatus: false,
            country_arr:[],
            code: '',   //地区号码
            phone: '',
            verify_code: '',
            count:"59", 
            gid: '',
            goods: {},
            urgent: '0',
            timeItems: [],
            timeId: 0,
            tags: '',
            isOpen: true,
            huabeiItems: [
                {
                    id: 0,
                    price: '',
                    rate: ''
                }
            ],
            hb_rates: [],
            hb_times: 3,
            per_cost: 0,
            modules_values: [],
            mid: '',
            remarkStatus: false,
            remarkContent: '',
            user_demand: '',
            price: 0,
            total: 0,
            eng_no: '',
            sms_show: true,
            isShowVerify: false,
            modalStatus: false,
            sheetStatus: false,
            service_description: '',
            modules: [],
            base_price: 0
        }
    },
    mounted(){
        
    },
    created(){
        this.gid = this.$route.query.gid
        this.price = this.$route.query.total
        this.tags = this.$route.query.tags
        this.modules_values = this.$route.query.modules
        this.eng_no = this.$route.query.eng_no

        if(!this.gid){
            this.gid = localStorage.primary_gid
            this.price = localStorage.primary_total
            this.tags = localStorage.primary_tags
            let modules_values = localStorage.primary_modules
            this.modules_values = modules_values.split(',')
            let eng_no = localStorage.primary_eng_no
            if(eng_no){
                this.eng_no = eng_no
            }
        }
        if(typeof this.price != 'string'){
            this.price = JSON.stringify(this.price)
        }
        
        if(this.price.indexOf('.')>-1){
            let arr = this.price.split('.')
            this.price = arr[0]
        }
        this.getCountryCodes()
        this.getUserInfo()
    },
    methods:{
        handlePayResult(paydata){
            var vm = this;
            let pay_url;
            if(vm.payType == "wxpay-h5"){
                pay_url = paydata.mweb_url;
            }else{
                pay_url = paydata.pay_url;
            }
            window.location.href = pay_url;
        },
        async pay(orderno){
            let vm = this;
            var url = window.config.payResult+'orderno=';
            let access_token =  localStorage.access_token;
            
            let info = {
                orderno: orderno,
                type: 'alipay',
                return_url: url,
                access_token: access_token,
                hb_fq_num: vm.hb_times
            }
            localStorage.huabei_num = vm.hb_times
            if(!vm.validToken()){
                return
            }                    
            
            vm.postPay(info)
        },
        async postPay( info){
            let vm = this;
            const res = await vm.$store.dispatch( 'wapPay' ,info);
            var data = res.data;
            var paydata = data.res.paydata;
            
            if(data.code == 0){
                vm.handlePayResult(paydata);
            }
        },
        closeSheet(){
            let vm = this
            vm.sheetStatus = true
            setTimeout(function(){
                vm.modalStatus = false
            },300)
        },
        openSheet(){
            let vm = this
            vm.modalStatus = true
            setTimeout(function(){
                vm.sheetStatus = false
            },300)
        },
        getSms(){
            var vm = this;
            this.count = 59;
            if(!vm.phone.replace(/\s+/g, "")){
                this.$toastlj("请输入手机号码")
                return
            }
            
            let info = {
               'phone':vm.phone
            }
            if(vm.code){
                info['country_code'] = vm.code
            }
            this.$store.dispatch("getVerifyCode",info).then((res)=>{
                var result = res.data;
                if(result.code == 0){
                     vm.countDown();
                     vm.sms_show = false;
                }
            })
        },
        countDown(){
            let vm = this;
            let interval = setInterval(function(){
                vm.count = vm.count -1;
                if(vm.count == 0){
                    vm.sms_show = true;
                    window.clearInterval(interval);  
                }
            },1000)
        },
        cancelRemark(){
            this.remarkStatus = false
        },
        finishRemark(){
            this.cancelRemark()
            this.user_demand = this.remarkContent
        },
        createOrder(){
            if(this.validToken()){
                this.modules_values.push(this.timeId)
                let data = {
                    access_token: localStorage.access_token,
                    info: {
                        gid: this.gid,
                        mid: this.mid,
                        phone: this.phone,
                        app_id: window.config.appid,
                        goods_module_values: this.modules_values
                    }
                }
                if(this.eng_no){
                    data.info['eng_no'] = this.eng_no
                }
                if(this.verify_code){
                    data.info['verify'] = this.verify_code
                }
                this.$store.dispatch('createOrder',data).then((res)=>{
                    let result = res.data
                    if(result.code == 0){
                        let order = result.res.order
                        let user = result.res.user
                        let goods = result.res.gd.goods
                        let vm = this
                        let data = _.find(this.timeItems,function(o){
                            return o.id == vm.timeId
                        })
                        let arr = data.name.split('（')
                        this.sa_m_submit_order(
                            order.total_price,
                            user.kxuid,
                            goods.description,
                            goods.category,
                            arr[0],
                            window.location.href,
                            this.tags.split(',')
                        )
                        if(this.huabeiStatus){  //选择花呗支付
                            this.pay(order.orderno)
                        }else {
                            this.$router.push({name:'pay',query:{orderno:result.res.order.orderno}})
                        }
                    }else {
                        this.$toastlj(res.data.message)
                    }
                })
            }
        },
        selectHBItem(index){
            this.hb_times = this.hb_rates[index].key
            this.per_cost = this.hb_rates[index].value
        },
        getSystemConfig(){
            let info = {
                app_id: '30001081'
            }
            this.$store.dispatch('getSystemConfig',info).then((res)=>{
                if(res.data.code===0){
                    let rates = res.data.res.hb_rates
                    this.total = parseFloat(this.price)+parseFloat(this.urgent)
                    for(let item in rates){
                        let num = (this.total)*(1+parseFloat(rates[item])/100)/parseFloat(item)
                        let el = {
                            key: item,
                            rate: rates[item],
                            value: num.toFixed(2)
                        }
                        this.hb_rates.push(el)
                    }
                }
            })
        },
        changeOpenStatus(){
            this.isOpen = !this.isOpen
        },
        selectTime(data){
            this.timeId = data.id
            this.urgent = data.price
            let arr = data.name.split('（')
            this.sa_m_package_selected(
              arr[0],
              true,
              this.goods.description
            )
            this.total = parseFloat(this.price)+parseFloat(this.urgent)
            for(let i=0;i<this.hb_rates.length;i++){
                let num = (this.total)*(1+parseFloat(this.hb_rates[i].rate)/100)/parseFloat(this.hb_rates[i].key)
                this.hb_rates[i].value = num.toFixed(2)
            }
        },
        getGoodsInfo(){
            let info = {
                gid: this.gid,
                api_version: window.config.api_version
            }
            this.$store.dispatch('getGoodsInfo',info).then((res)=>{
                let result = res.data
                if(result.code===0){
                    this.goods = result.res.data.goods
                    this.modules = result.res.data.groups[0].modules
                    this.base_price = this.modules[0].price
                    let properties = this.modules[0].properties
                    let resData = _.find(properties,function(o){
                        return o.type == 2
                    })
                    this.timeItems = resData.values
                    this.timeId = this.timeItems[0].id
                    
                    this.mid = this.modules[0].id
                    this.service_description = this.modules[0].description
                    this.getSystemConfig()
                }
            })
        },
        getUserInfo(){
            let vm = this
            let access_token = localStorage.access_token;
            let info = {
                'access_token':access_token
            };
            this.$store.dispatch("getUserinfo",info).then((res)=>{
                if(res.data.code===0){
                    let data = res.data.res
                    this.phone = data.user_bind_phone
                    if(!this.phone){
                        this.isShowVerify = true
                    }else {
                        this.isShowVerify = false
                    }
                    this.code = data.country_code
                    this.getGoodsInfo()
                }else if(res.data.code===1200){
                    vm.refreshToken()
                }
            })
        },
        goBack(){
            this.$router.go(-1)
        },
        showPicker() {
            this.$refs.pickers.show();
        },
        handlePickerConfirm(item){
            this.country = this.country_arr[item[0].index].country;
            this.code = this.country_arr[item[0].index].code;
        },
        goRemark(){
            this.remarkStatus = true
            this.remarkContent = this.user_demand
        },
        changeHuaBeiList(){
            let vm = this
            vm.huabeiStatus = !vm.huabeiStatus
            if(!vm.huabeiStatus){
                setTimeout(function(){
                    vm.hb_times = vm.hb_rates[0].key
                    vm.per_cost = vm.hb_rates[0].value
                },500)
            }
        },
        getCountryCodes(){
            var vm = this;
            this.$store.dispatch("getCountryCodes").then((res)=>{
                var result = res.data;
                if(result.code == 0){
                    let countryCodes = result.res;
                    vm.country_arr = countryCodes;
                    let arr1 = [];
                    for(let i=0;i<countryCodes.length;i++){
                        let code = `<span class="country_code">+${countryCodes[i].code}</span><span class="country_name">${countryCodes[i].country}</span>`;
                        arr1.push(code)
                    }
                    vm.picker.slot.push(arr1)
                }
            })
        },
    },
    components:{
        AwesomePicker
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/ConfirmOrderV3.vue